import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
const baseStyle = defineStyle({
  borderColor: 'GREYSCALE.SATELLITE'
});
export const dividerTheme = defineStyleConfig({
  baseStyle
});